export const ADMIN_NOTIFICATION_SEVERITY = {
  INFO: 'INFO',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  CRITICAL: 'CRITICAL'
};

const LEGACY_TYPE_MAP = {
  ADMIN_BROADCAST: {
    eventType: 'NOTIFICATION_OPS',
    eventAction: 'BROADCAST_PUBLISHED',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.INFO,
    eventTargetArea: 'admin_notifications'
  },
  TARGETED: {
    eventType: 'NOTIFICATION_OPS',
    eventAction: 'TARGETED_PUBLISHED',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.INFO,
    eventTargetArea: 'admin_notifications'
  },
  IKM_ALERT: {
    eventType: 'NOTIFICATION_OPS',
    eventAction: 'IKM_ALERT',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.ACTION_REQUIRED,
    eventTargetArea: 'admin_notifications'
  },
  RECIPE_ISSUE: {
    eventType: 'RECIPE_ISSUE',
    eventAction: 'SUBMITTED',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.ACTION_REQUIRED,
    eventTargetArea: 'admin_recipe_feedback'
  },
  PRICE_MISMATCH_DETECTED: {
    eventType: 'PRICE_RISK',
    eventAction: 'MISMATCH_DETECTED',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.ACTION_REQUIRED,
    eventTargetArea: 'admin_pricing'
  },
  SCALING_PARITY_FAIL: {
    eventType: 'PRICE_RISK',
    eventAction: 'SCALING_PARITY_FAIL',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.CRITICAL,
    eventTargetArea: 'admin_pricing'
  }
};

export function normalizeAdminNotificationMeta(notification) {
  if (!notification || typeof notification !== 'object') {
    return {
      eventType: 'UNKNOWN',
      eventAction: 'UNKNOWN',
      eventSeverity: ADMIN_NOTIFICATION_SEVERITY.INFO,
      eventTargetArea: 'admin_notifications'
    };
  }

  if (notification.eventType && notification.eventSeverity && notification.eventTargetArea) {
    return notification;
  }

  const legacyType = String(notification.type || '').toUpperCase();
  const mapped = LEGACY_TYPE_MAP[legacyType] || {
    eventType: legacyType || 'UNKNOWN',
    eventAction: 'UNKNOWN',
    eventSeverity: ADMIN_NOTIFICATION_SEVERITY.INFO,
    eventTargetArea: 'admin_notifications'
  };

  return {
    ...notification,
    ...mapped
  };
}

export function isPricingRiskNotification(notification) {
  const n = normalizeAdminNotificationMeta(notification);
  return n.eventType === 'PRICE_RISK' || n.eventTargetArea === 'admin_pricing';
}

export function isRecipeIssueNotification(notification) {
  const n = normalizeAdminNotificationMeta(notification);
  return n.eventType === 'RECIPE_ISSUE';
}

export function isCriticalNotification(notification) {
  const n = normalizeAdminNotificationMeta(notification);
  return n.eventSeverity === ADMIN_NOTIFICATION_SEVERITY.CRITICAL;
}

function hasTruthyValue(value) {
  return !(value === null || value === undefined || value === '');
}

export function isAcknowledgedUnresolvedNotification(notification) {
  const n = normalizeAdminNotificationMeta(notification);
  const filters = n && typeof n.targetFilters === 'object' ? n.targetFilters : {};
  const acknowledged = hasTruthyValue(filters.acknowledgedAt);
  const resolved = hasTruthyValue(filters.resolvedAt);
  return acknowledged && !resolved;
}
